import { render } from "./VerificationStatusPending.vue?vue&type=template&id=428c4e79&ts=true"
import script from "./VerificationStatusPending.vue?vue&type=script&lang=ts"
export * from "./VerificationStatusPending.vue?vue&type=script&lang=ts"

import "./VerificationStatusPending.vue?vue&type=style&index=0&id=428c4e79&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/transaction/VerificationStatusPending.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "428c4e79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('428c4e79', __exports__)) {
    api.reload('428c4e79', __exports__)
  }
  
  module.hot.accept("./VerificationStatusPending.vue?vue&type=template&id=428c4e79&ts=true", () => {
    api.rerender('428c4e79', render)
  })

}


export default __exports__